import * as React from 'react';
import { Link } from 'react-router-dom';
import './header.css';
import GeniebookLogo from '../assets/icons/GeniebookLogo.svg';

const Header = () => {

    return (
        <>
        <header className="z-50 flex w-full bg-white flex-shrink">
            <div className="header-container">
                <Link to="/">
                    <img src={GeniebookLogo} className="logo" alt="" />
                </Link>
                <div className="max-md:hidden flex float-right">
                    <a href="https://geniebook.com/" target="_blank" rel="noreferrer">
                        <div className="faq">
                            <label>?</label>
                        </div>
                    </a>
                </div>
            </div>
        </header>
        </>
    )
}

export default Header;
